import { Input, SegmentedControl } from '@vnetwork/ui/primitives';
import { Field } from '@vnetwork/ui/forms';
import type { DomainDraft } from './wizard-types';

/** Step 1 — domain name + origin server. */
export function StepOrigin({
  draft,
  set,
}: {
  draft: DomainDraft;
  set: (patch: Partial<DomainDraft>) => void;
}) {
  return (
    <>
      <Field
        label="Domain"
        required
        description="The FQDN you want to serve, e.g. www.example.com."
      >
        {(props) => (
          <Input
            {...props}
            value={draft.domain}
            placeholder="www.example.com"
            onChange={(e) => set({ domain: e.target.value })}
          />
        )}
      </Field>

      <Field label="Origin server" description="Where the edge fetches uncached content from.">
        {(props) => (
          <Input
            {...props}
            value={draft.origin}
            placeholder="origin.example.com"
            onChange={(e) => set({ origin: e.target.value })}
          />
        )}
      </Field>

      <Field label="Origin scheme" description="Protocol the edge uses to reach your origin.">
        {() => (
          <SegmentedControl
            size="sm"
            items={[
              { value: 'https', label: 'HTTPS' },
              { value: 'http', label: 'HTTP' },
            ]}
            value={draft.originScheme}
            onValueChange={(v) => set({ originScheme: v as DomainDraft['originScheme'] })}
            aria-label="Origin scheme"
          />
        )}
      </Field>
    </>
  );
}
